import React, { FC, ReactElement, useMemo } from 'react'
import { EMPTY_SPACE_STRING, EMPTY_STRING } from '../../Constants/Separators'
import { StringUtils } from '../../../../NonReact/utils/StringUtils'

type Props = {
    name: string
}

export const DEFAULT_USER_FULL_NAMES: string[] = ['Full Name Not Specified', 'Default Administrator User']

export const UserBadge: FC<Props> = ({ name }: Props): ReactElement => {
    const initials: string = useMemo(
        (): string =>
            StringUtils.replaceArrayItemsInString(
                name.replace(/[^A-Za-z0-9\s]/g, EMPTY_STRING),
                DEFAULT_USER_FULL_NAMES,
                '?'
            )
                .split(EMPTY_SPACE_STRING)
                .filter(
                    (_: string, index: number, array: string[]): boolean => index === 0 || index === array.length - 1
                )
                .map((word: string): string => word[0])
                .join(EMPTY_STRING),
        [name]
    )

    return (
        <div className='user-badge'>
            <div className='user-badge-text'>{initials}</div>
        </div>
    )
}
